import Image from "next/image";
import { defaultLoader } from "utils/cloudinaryUtils";

const CarfaxPlugin = ({
    partnerIdCarfax,
    companyName,
    vin,
    carfaxImageUrl,
    carfaxUrl,
    carfaxButtonUrl,
    width=198,
    height=37,
}: {
  partnerIdCarfax: string;
  companyName: string;
  vin: string;
  carfaxImageUrl: string;
  carfaxUrl: string;
  carfaxButtonUrl: string;
  width?: number;
  height?: number;
}) => {
    const newCarfaxUrl = carfaxUrl?.length > 0 ? carfaxUrl: `http://www.carfax.com/VehicleHistory/p/Report.cfx?partner=${partnerIdCarfax}&vin=${vin}`;
    const newCarfaxImageUrl = carfaxButtonUrl?.length > 0 ? carfaxButtonUrl : carfaxImageUrl;
    return (
        <div className="row">
            <div className="col-md-12">
                <a
                    className="carfax-div"
                    target="_blank"
                    href={newCarfaxUrl}
                    rel="noreferrer"
                >
                    <Image
                        loader={defaultLoader}
                        alt={`${companyName} Carfax`}
                        className="img-responsive p-b-10 p-t-10"
                        src={newCarfaxImageUrl}
                        height={height}
                        width={width}
                        loading="lazy"
                    />
                </a>
            </div>
        </div>
    );
};

export default CarfaxPlugin;
